import { Box, Typography } from '@mui/material';

export interface ChatPillTabProps {
  label: string;
  isActive: boolean;
  onClick: () => void;
  'data-testid'?: string;
}

export const ChatPillTab = ({
  label,
  isActive,
  onClick,
  'data-testid': dataTestId,
}: ChatPillTabProps) => (
  <Box
    data-testid={dataTestId}
    onClick={onClick}
    sx={{
      display: 'flex',
      alignItems: 'center',
      // the ds Segmented: the current tab on the raised tile in ink, never a coloured pill
      px: '14px',
      height: 34,
      borderRadius: '9px',
      cursor: 'pointer',
      background: isActive ? 'var(--tx-sel-bg)' : 'transparent',
      boxShadow: isActive ? 'var(--tx-sel-shadow)' : 'none',
      transition: 'background-color 0.15s ease, box-shadow 0.15s ease',
      '&:hover .chat-pill-label': { color: 'var(--tx-text)' },
    }}>
    <Typography
      className="chat-pill-label"
      sx={{
        fontSize: 13,
        fontWeight: 600,
        letterSpacing: '-0.02em',
        color: isActive ? 'var(--tx-text)' : 'var(--tx-muted)',
        userSelect: 'none',
      }}>
      {label}
    </Typography>
  </Box>
);

export default ChatPillTab;
